import React from 'react'

import { IUserData, IContact } from './user/user.interface'

type UserContextProps = {
  users: Array<IUserData>
  setUsers: (users: Array<IUserData>) => void
  contactRoles: any
  setContactRoles: (roles: any) => void
  modifiedUsers: Array<string>
  setModifiedUsers: (users: Array<string>) => void
  contacts: Array<IContact>
  setContacts: (contacts: Array<IContact>) => void
  selectedContact: IContact
  setSelectedContact: (contact: IContact) => void
  contactUsers: Array<IUserData>
  setContactUsers: (users: Array<IUserData>) => void
}

const UserContext = React.createContext<UserContextProps>({
  users: [],
  setUsers: () => {},
  contactRoles: {},
  setContactRoles: () => {},
  modifiedUsers: [],
  setModifiedUsers: () => {},
  contacts: [],
  setContacts: () => {},
  selectedContact: {
    id: '',
    name: '',
    roles: [],
  },
  setSelectedContact: () => {},
  contactUsers: [],
  setContactUsers: () => {},
})

export const UserProvider = UserContext.Provider
export const UserConsumer = UserContext.Consumer
export default UserContext
